import { PUZZLE_TZ, puzzleDateFor } from '@familyhub/shared';

/**
 * The module's own date helpers (it imports none from another module — the
 * independence rule). The puzzle turns over at the household's local midnight,
 * so "today" is the Amsterdam calendar date.
 */

/** Today's puzzle date, `YYYY-MM-DD`, in the household's zone. */
export const todayPuzzleDate = (): string => puzzleDateFor(new Date(), PUZZLE_TZ);

/** "Vrijdag 5 september" — the puzzle's day, written the way the household reads it. */
export function formatPuzzleDate(dateString: string): string {
  const [y, m, d] = dateString.split('-').map(Number);
  // Noon UTC keeps the date stable whatever the runtime's own zone.
  const dt = new Date(Date.UTC(y!, m! - 1, d!, 12));
  const s = dt.toLocaleDateString('nl-NL', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    timeZone: 'UTC',
  });
  return s.charAt(0).toUpperCase() + s.slice(1);
}
